import React, { ButtonHTMLAttributes, ReactNode } from "react";
import { FiPlus } from "react-icons/fi";
import { Container } from "./styles";

interface PrimaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string;
  loading?: boolean;
  showPlusIcon?: boolean;
  icon?: ReactNode;
  children?: ReactNode;
}

export function PrimaryButton({
  text,
  loading = false,
  showPlusIcon = false,
  icon,
  children,
  ...rest
}: PrimaryButtonProps) {
  return (
    <Container disabled={loading} {...rest}>
      {showPlusIcon && !loading && <FiPlus size={18} />}
      {!loading && icon}
      {text || children}
      {loading && <div className="loading" />}
    </Container>
  );
}
